import { useState } from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

// Small info icon with a tooltip, safe to place inside a nav link (tap toggles on touch).
export function NavInfo({ text, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <span role="button" tabIndex={0} aria-label={text} data-testid={testid}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
            className="inline-flex items-center opacity-60 hover:opacity-100 transition-opacity">
            <Info className="w-3.5 h-3.5" strokeWidth={1.75} />
          </span>
        </TooltipTrigger>
        <TooltipContent side="right" className="max-w-[220px] text-xs normal-case tracking-normal" data-testid={`${testid}-content`}>
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
